import { render, staticRenderFns } from "./securityPassword.vue?vue&type=template&id=2f545546"
import script from "./securityPassword.vue?vue&type=script&lang=js"
export * from "./securityPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports